import axios from 'axios';


import __CFG from '@/conf/config.json';


import * as __modal_details from '@/modal_details.js';


import { bus } from '@/main';


import loanStore from '@/stores/loanStore';


//const accessToken = localStorage.getItem('access_token');

const instance = axios.create({
  //baseURL: __CFG.secondaryEndpoint,
  baseURL: __CFG.primaryEndpoint,
  timeout: 35000,
  withCredentials: true
//  headers: {'Authorization': `Bearer ${accessToken}`},
});



export default {




  data: function () {
    return {

      minAmount: this.getConf('min_amount'),
      minTenor: this.getConf('min_tenor'),

      errors: null

    }
  },


  // Globalne parametry wniosku - proxy do reaktywnego loanStore.
  // Wszystkie instancje korzystajace z tego mixinu czytaja/pisza ten sam store,
  // wiec wartosci propaguja sie same (bez busa 'values_set').
  computed: {
    loanAmount: {
      get() { return loanStore.loanAmount; },
      set(v) { loanStore.loanAmount = v; }
    },
    loanTenor: {
      get() { return loanStore.loanTenor; },
      set(v) { loanStore.loanTenor = v; }
    },
    tenorSign: {
      get() { return loanStore.tenorSign; },
      set(v) { loanStore.tenorSign = v; }
    },
    total: {
      get() { return loanStore.total; },
      set(v) { loanStore.total = v; }
    },
    interest: {
      get() { return loanStore.interest; },
      set(v) { loanStore.interest = v; }
    },
    commission: {
      get() { return loanStore.commission; },
      set(v) { loanStore.commission = v; }
    },
    service: {
      get() { return loanStore.service; },
      set(v) { loanStore.service = v; }
    },
    insurance: {
      get() { return loanStore.insurance; },
      set(v) { loanStore.insurance = v; }
    },
    rrso: {
      get() { return loanStore.rrso; },
      set(v) { loanStore.rrso = v; }
    },
    dailyInterest: {
      get() { return loanStore.dailyInterest; },
      set(v) { loanStore.dailyInterest = v; }
    },
    finishDate: {
      get() { return loanStore.finishDate; },
      set(v) { loanStore.finishDate = v; }
    }
  },



  directives: {
    dynamic: {
      bind(el, binding, vn) {
        el.innerHTML = binding.value;

      },
      update(el, binding) {
        el.innerHTML = binding.value;
      },
    },
  },



  methods: {

    passwordPolicy(v){
      return (/(?=.*\d)/.test(v) ? 1 : 0) + (/(?=.*[a-z])/.test(v) ? 1 : 0) + (/(?=.*[A-Z])/.test(v) ? 1 : 0) + (/(?=.*\W)/.test(v) ? 1 : 0) >= 3 ;
    },

    get(route, queryParameters = null, opt ={} ) {
      return this._sendRequest(instance.get(route, { params: queryParameters, ...opt}));
    },
    post(route, parameters = null, queryParameters = null) {
      return this._sendRequest(instance.post(route, parameters, { params: queryParameters }));
    },
    put(route, parameters = null, queryParameters = null) {
      return this._sendRequest(instance.put(route, parameters, { params: queryParameters }));
    },
    delete(route, parameters = null, queryParameters = null) {
      return this._sendRequest(instance.delete(route, parameters, { params: queryParameters }));
    },
    patch(route, parameters = null, queryParameters = null) {
      return this._sendRequest(instance.patch(route, parameters, { params: queryParameters }));
    },
    _sendRequest(request) {
      return new Promise((resolve, reject) => {
        request.then(response => {
          resolve(response)
        }).catch(error => {
          // siatka bezpieczenstwa: gdyby _errorResponse rzucil wyjatek,
          // promise i tak musi sie rozstrzygnac (inaczej isLoading w nieskonczonosc)
          try {
            this._errorResponse(error, reject);
          }
          catch (e) {
            this.log('_errorResponse threw', e);
            reject(error);
          }
        });
      });
    },


/*    _errorResponse(error, reject) {
      let dt = error.response.data;

      switch(error.response.status) {
        case 401:
          // Permission Error (logout)
          break;

        case 402:
          // Your account is expired, (redirect to BUY)
          break;

        case 403:
          // forbidden
          Object.keys(dt).map(k => {

            if (k.match(/ERROR/)) {
              this.errors = dt[ k ];
            }
          });

          reject(error);
          break;

        case 422:
          // this is a validation error

          Object.keys(dt).map(k => {

            if (k.match(/Message/)) {

              this.errors = dt[ k ];
            }
          });

          reject(error);
          break;

        default:
          error.message = error.response.data.message;
          reject(error);
          break;
      }


      // if not matched any type of error
      if (!this.errors) {
        this.errors = 'Wystąpił błąd!';
      }
    },
*/

    _errorResponse(error, reject) {

      // send log
      if (typeof error != 'object') {

        this.log('not object', error);
      }
      else {


        if ( error.config && error.config.url && error.config.url.match('session') && error.response && error.response.status == 403 ) {

        }
        else {

          this.log(error, ' response is ', error.response);
        }
      }



      if (!error) {
        reject(error);
        return;
      }



      let dt = typeof error == 'object' && (dt = error.response) && dt.data;


      if (!dt) {

        this.log('_errorResponse handler', ' details ', error);

        reject(error);
        return;
      }


      this.log('_errorResponse handler', ' details ', error.response);




      switch(error.response.status) {
        case 401:
          // Permission Error (logout)
          // WAZNE: i tak odrzucamy promise, inaczej wywolanie nigdy sie nie
          // rozstrzyga (np. existCheck -> isLoading w nieskonczonosc).
          reject(error);
          break;

        case 402:
          // Your account is expired, (redirect to BUY)
          reject(error);
          break;

        case 403:
          // forbidden
          Object.keys(dt).map(k => {

            if (k.match(/ERROR/)) {
              this.errors = dt[ k ];
            }
          });

          reject(error);
          break;

        case 422:
          // this is a validation error

          Object.keys(dt).map(k => {

            if (k.match(/Message/)) {

              this.errors = dt[ k ];
            }
          });

          reject(error);
          break;

        default:
          error.message = error.response.data.message;
          reject(error);
          break;
      }


      // if not matched any type of error
      if (!this.errors) {
        this.errors = 'Wystąpił błąd!';
      }
    },




    getConf(key){

      return __CFG.hasOwnProperty(key) ? __CFG[ key ] : null;
    },




    log() {
      if (window.LogService) {
        window.LogService.log.apply(window.LogService, arguments);
        return;
      }

      // Fallback jesli LogService nie gotowy
      console.log.apply(console, ['[LOG]'].concat(Array.prototype.slice.call(arguments)));
    },



    pageTop(){

      // go by delay
      setTimeout(() => {
        window.scrollTo(0,0);
      }, 500);
    },


    toast(msg='') {

      this.$toasted.show(msg,{
           theme: "bubble",
           position: "top-right",
           className: 'toster',
           duration : 1500
        });
    },

    // disable / enable window scroll
    scrollFreeze(disable=true){


      if (disable) {

        var x=window.scrollX;
        var y=window.scrollY;
        window.onscroll=function(){window.scrollTo(x, y);};
      }
      else {
        window.onscroll=null;
      }
    },

    echo(name='default', ...args){

      bus.$emit(name, ...args);
    },


    listen(name='default', callback=null){

      bus.$on(name, callback);
    },


    // set loan params values
    setValues(v=null, t='30', s='d', f=null){

   

        v = parseFloat(v);

        if (!this.loan_params.hasOwnProperty(String(t+s))) {
            t = this.minTenor;
            v = this.minAmount;  
            s = this.tenorSign;
        }


       

        if ( this.loan_params.hasOwnProperty(String(t+s)) && this.loan_params[t+s].hasOwnProperty(String(v)) ){

          let dat = this.loan_params[t+s][v],
              now = new Date(),
              newDate = s == 'm' ? new Date(now.setMonth(now.getMonth() + t)) : new Date(Date.now() + t * 24*60*60*1000),
              iso = newDate.toISOString();

          this.loanAmount = v;
          this.loanTenor = t;
          this.tenorSign = s;

          this.total = ((dat[0] * (this.loanTenor-1)) + dat[1]).toFixed(2);
          this.interest = dat[2];
          this.service = dat[3];
          this.commission = dat[4];
          this.insurance = dat[5];
          this.rrso = dat[6];


          this.dailyInterest = parseInt(dat[4]) / 30;

          this.finishDate = f || iso.split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');

          // wartosci trafiaja do loanStore (computed set) i propaguja sie same
        }
    },



    getModalContent(name){

      if (!__modal_details[name]) {
        return 'no data';
      }


      switch (name) {

        case 'info_form':
          return [
            ['{m%POZYCZKA.KAPITAL}', this.loanAmount],
            ['{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY}', this.total],

            

            ['{POZYCZKA.OPROCENTOWANIE_STOPA}', this.getConf('nbp_interest_rate')],
            ['{m%POZYCZKA.OPROCENTOWANIE_STOPA}', this.getConf('nbp_interest_rate')],
            ['{POZYCZKA.STOPA_NBP}', this.getConf('nbp_penalty_rate')],
            ['{m%POZYCZKA.STOPA_NBP}', this.getConf('nbp_penalty_rate')],
            ['{POZYCZKA.PRZYKLAD}', this.getConf('loan_sample')],
            ['{POZYCZKA.PRZYKLAD_KWOTA}', this.getConf('sample_amount')],
            ['{POZYCZKA.PRZYKLAD_PROWIZJA}', this.getConf('sample_fee')],
            ['{POZYCZKA.PRZYKLAD_ODSETKI}', this.getConf('sample_interest')],
            ['{POZYCZKA.PRZYKLAD_OBSLUGA}', this.getConf('sample_service')],
            ['{POZYCZKA.PRZYKLAD_KOSZT}', this.getConf('sample_cost')],
            ['{POZYCZKA.PRZYKLAD_RRSO}', this.getConf('sample_rrso')],
            ['{POZYCZKA.PRZYKLAD_DATA}', this.getConf('sample_valid_from')],
            ['{POZYCZKA.PRZYKLAD_CALKOWITA_KWOTA}', this.getConf('sample_total')],


            ['{POZYCZKA.RRSO}', this.rrso+' '],
            ['{POZYCZKA.DATA_SPLATY}r.', this.finishDate+'r.'],
            ['{POZYCZKA.OPLATA_POCZATKOWA}', this.service],
            ['{m%POZYCZKA.OPLATA_POCZATKOWA}', this.service],
            ['{POZYCZKA.OPROCENTOWANIE}', this.interest],
            ['{m%POZYCZKA.OPROCENTOWANIE}', this.interest],
            ['{POZYCZKA.ODSETKI_DZIENNE}', parseFloat(this.dailyInterest).toFixed(2)]
          ]
          .reduce((acc, itm) => acc.replaceAll(new RegExp(itm[0], 'g'), itm[1]), __modal_details[ name ]);



        default:
          return __modal_details[ name ];
      }

    },


    copyToClipboard (event) {

      let target = 'string' == typeof event ? document.getElementById(event) : (event.target.tagName == 'I' ? event.target.parentNode : event.target);


/*
      var textarea = document.createElement('textarea')
      textarea.id = 'temp_element'
      textarea.style.height = 0
      document.body.appendChild(textarea)
      textarea.value = target.innerText; //document.getElementById(containerid).innerText

      var selector = document.querySelector('#temp_element')
      selector.select()
      document.execCommand('copy')
      document.body.removeChild(textarea);
*/


      var textArea;

      function isOS() {
        //can use a better detection logic here
        return navigator.userAgent.match(/ipad|iphone/i);
      }

      function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.readOnly = true;
        textArea.contentEditable = true;
        textArea.value = text;
        document.body.appendChild(textArea);
      }

      function selectText() {
        var range, selection;

        if (isOS()) {
          range = document.createRange();
          range.selectNodeContents(textArea);
          selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          textArea.setSelectionRange(0, 999999);
        } else {
          textArea.select();
        }
      }

      function copyTo() {
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }

      createTextArea(target.innerText);
      selectText();
      copyTo();




      this.toast('Skopiowano!');
    },



    formatCurrency: function(num, noDecimals=true, addCurrencySign=false, noEmptyCents=true) {
        var cents, sign;

        num = String(num).replace(/\$|\,/g,'');


        if(isNaN(num))
          num = "0";

        sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        cents = num%100;
        num = Math.floor(num/100).toString();

        if(cents<10)
          cents = "0" + cents;

        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
          num = num.substring(0,num.length-(4*i+3)) + ' ' + num.substring(num.length-(4*i+3));

       return (
             ((addCurrencySign) ? '<span class="currency-format-sign">' + '_CURRENCY_SIGN_'.t() + '</span> ' : '')
           + ((sign)?'':'-')
          + (parseInt(num) == 0 && String(cents).match(/00/) ? '<span class="currency-format-value-zero">'+ num + '</span>' : num )
          + ((noDecimals) ? '' : ((String(cents).match(/00/) ? (noEmptyCents ? ',00' : '' //',-'
              ) : ','+cents)))


       );
      }


  },



  created() {

  }



};



// WEBPACK FOOTER //
// ./src/mixins/common.js